import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['activeImage', 'activeVideo', 'thumbnail']

  connect() {
    this.thumbnailTargets[0].classList.add('ring-accent-800')
    this.thumbnailTargets[0].classList.remove('ring-transparent')
  }

  showImage(event) {
    this.activeImageTarget.src = event.target.src
    this.activeImageTarget.classList.remove('hidden')

    if (this.hasActiveVideoTarget) {
      this.activeVideoTarget.classList.add('hidden')
    }

    this.updateThumbnails(event.target)
  }

  showVideo(event) {
    this.activeVideoTarget.classList.remove('hidden')
    this.activeImageTarget.classList.add('hidden')
    this.activeVideoTarget.src = event.target.src
    this.activeVideoTarget.play()
    this.updateThumbnails(event.target)
  }

  updateThumbnails(selectedElement) {
    this.thumbnailTargets.forEach((thumbnail) => {
      if (thumbnail === selectedElement) {
        thumbnail.classList.add('ring-accent-800')
        thumbnail.classList.remove('ring-transparent')
      } else {
        thumbnail.classList.remove('ring-accent-800')
        thumbnail.classList.add('ring-transparent')
      }
    })
  }
}
